module.exports = __webpack_public_path__ + "img/lights.acc46f14.png";